import { useEffect, useState } from "react";
import useSiteStore from "../../store/useSiteStore";
import { fetchWithAuth } from "digimaker-ui/util";
import { Alert, Button, Table } from "react-bootstrap";

export const Makkertorg = () => {
  useEffect(() => {
    fetchList();
  }, []);

  const { site } = useSiteStore();
  const [list, setList] = useState<Array<any> | null>(null);

  const fetchList = async () => {
    const data = await fetchWithAuth(
      process.env.REACT_APP_BRIDGE_API_URL + "/makkertorg/list?site=" + site.id
    );
    setList(data.data);
  };

  const deleteUser = async (id) => {
    const data = await fetchWithAuth(
      process.env.REACT_APP_BRIDGE_API_URL +
        "/clubadmin/makkertorg/delete?site_id=" +
        site.id +
        "&id=" +
        id
    );
    if (data.error === false) {
      fetchList();
    } else {
      window.alert(data.data);
    }
  };

  return (
    <div style={{ padding: 10 }}>
      <h2>Makkertorg</h2>
      {list && list.length > 0 && (
        <Table hover style={{ marginTop: 10 }}>
          <thead>
            <tr>
              <th>Medlemnummer</th>
              <th>Navn</th>
              <th>Mobil</th>
              <th>Epost</th>
              <th>Kommentar</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {list.map((item: any, index: number) => (
              <tr key={index}>
                <td>
                  {item.first_name} {item.last_name}
                </td>
                <td>{item.member_number}</td>
                <td>{item.mobile}</td>
                <td>{item.email}</td>
                <td>{item.comment}</td>
                <td>
                  <Button
                    size="sm"
                    variant="secondary"
                    onClick={() => {
                      if (
                        window.confirm(
                          "Er du sikker på at du vil slette " +
                            item.first_name +
                            " " +
                            item.last_name +
                            "?"
                        )
                      ) {
                        deleteUser(item.id);
                      }
                    }}
                  >
                    <i className="fa fa-trash"></i>&nbsp;Fjerne
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
      {list && list.length === 0 && (
        <Alert variant="info">Igen data funnet.</Alert>
      )}
    </div>
  );
};
